import {
  NuvemEnvioCreateDispatchesRequestDto,
  NuvemEnvioCreateDispatchesResponseDto,
  NuvemEnvioSimulateDispatchChargeRequestDto,
  NuvemEnvioSimulateDispatchChargeResponseDto,
  NuvemEnvioCreateCreditRechargeRequestDto,
  NuvemEnvioCreateCreditRechargeResponseDto,
} from '@tiendanube/common';
import axios from 'App/axios';

const createNuvemEnvioLabels = async (
  payload: NuvemEnvioCreateDispatchesRequestDto,
): Promise<NuvemEnvioCreateDispatchesResponseDto> => {
  const { data } = await axios.post('nuvem-envio/dispatches', payload);
  return data;
};

const simulateNuvemEnvioLabels = async (
  payload: NuvemEnvioSimulateDispatchChargeRequestDto,
): Promise<NuvemEnvioSimulateDispatchChargeResponseDto> => {
  const { data } = await axios.post(
    'nuvem-envio/dispatches/simulate-charge',
    payload,
  );
  return data;
};

const creditRechargeNuvemEnvioLabels = async (
  payload: NuvemEnvioCreateCreditRechargeRequestDto,
): Promise<NuvemEnvioCreateCreditRechargeResponseDto> => {
  const { data } = await axios.post(
    'nuvem-envio/statement/credit-recharges',
    payload,
  );
  return data;
};

export default {
  createNuvemEnvioLabels,
  simulateNuvemEnvioLabels,
  creditRechargeNuvemEnvioLabels,
};
